<template lang="pug">
.featured-products
  Tabs(v-model="active" :title="__('Featured Products')" :tabs="tabNames")
  ProductCarousel.contents(
    v-for="category in categories"
    :key="category.id"
    :category="category.id"
    :podId="category.podId"
  )
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useRogue } from '@/js/services/Rogue'

const defaultCategories = [
  { name: 'Featured', id: '' },
  { name: 'CrossFit®', id: '-crossfit' },
  { name: 'Powerlifting', id: '-powerlifting' },
  { name: 'Olympic', id: '-olympic' },
  { name: 'Strongman', id: '-strongman' },
]

const rogue = useRogue()

let prefix = '/na-featured'
if (['EUR', 'AUS', 'GBR'].includes(rogue.site.code)) {
  prefix = '/featured'
}

const active = ref('Featured')
const tabNames = defaultCategories.map(c => c.name)
const categories = computed(() => defaultCategories.map(cat => {
  const id = cat.id === '' && prefix === '/na-featured' ? '/featured' : prefix + cat.id

  return {
    name  : cat.name,
    id,
    podId : `homepage${id.replace('/', '-')}`,
  }
}).filter(category => category.name === active.value))
</script>

<style scoped lang="scss">
.contents {
  overflow: visible;
}

:deep() {
  .tab-header {
    margin-bottom: $space-s;
  }
}
</style>
